<template>
    <div class="tabla-scroll pa-2">
        <!-- <div class="row">
            <div class="col-xs-3">
                <v-select :items="fsucursales" item-value="id" v-model="search" clearable label="Sucursal:" /> 
            </div>
            <div class="col-xs-3">
                <v-select :items="fpuntos" item-value="id" v-model="search" clearable label="Punto de venta:" /> 
            </div>
            <div class="col-xs-2">
                <v-select :items="festado_sistema" item-value="id" v-model="search" clearable label="Estado sistema:" /> 
            </div>
            <div class="col-xs-2">
                <v-select :items="festados" item-value="id" v-model="search" clearable label="Estado:" /> 
            </div>
            <div class="col-xs-2">
                <v-select :items="fdocsector" item-value="id" v-model="search" clearable label="Doc sector:" /> 
            </div>
        </div>  -->
        <v-card>
            <v-card-title>
                Busqueda
                <v-btn elevation="2" @click="get_datos">Actualizar</v-btn>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Busqueda" single-line
                    hide-details></v-text-field>
            </v-card-title>
        </v-card>
        <v-data-table  :headers="headers" :items="desserts" :loading="loading" :search="search" dense     show-group-by

            xitems-per-page="150" xdisable-items-per-page xdisable-pagination xhide-default-footer class="fixed-table"
            fixed-header height="70vh">
            <template v-slot:[`item.registradoSistema`]="{ item }">
                {{ item.registradoSistema ? 'SI' : 'NO' }}
            </template>
            <template v-slot:[`item.id_esam`]="{ item }">
                <v-chip small :color="item.inscripcion_id ? 'green' : 'red'" dark>
                    {{ item.id_esam }}
                </v-chip>
            </template>
            <template v-slot:[`item.ci`]="{ item }">
                <v-chip small :color="item.persona_id ? 'green' : 'red'" dark>
                    {{ item.ci }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m1`]="{ item }">
                <v-chip small :color="item.nota_m1 == null ? 'grey' : item.migrado_nota_m1 ? 'green' : 'red'" dark>
                    {{ item.nota_m1 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m2`]="{ item }">
                <v-chip small :color="item.nota_m2 == null ? 'grey' : item.migrado_nota_m2 ? 'green' : 'red'" dark>
                    {{ item.nota_m2 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m3`]="{ item }">
                <v-chip small :color="item.nota_m3 == null ? 'grey' : item.migrado_nota_m3 ? 'green' : 'red'" dark>
                    {{ item.nota_m3 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m4`]="{ item }">
                <v-chip small :color="item.nota_m4 == null ? 'grey' : item.migrado_nota_m4 ? 'green' : 'red'" dark>
                    {{ item.nota_m4 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m5`]="{ item }">
                <v-chip small :color="item.nota_m5 == null ? 'grey' : item.migrado_nota_m5 ? 'green' : 'red'" dark>
                    {{ item.nota_m5 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m6`]="{ item }">
                <v-chip small :color="item.nota_m6 == null ? 'grey' : item.migrado_nota_m6 ? 'green' : 'red'" dark>
                    {{ item.nota_m6 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m7`]="{ item }">
                <v-chip small :color="item.nota_m7 == null ? 'grey' : item.migrado_nota_m7 ? 'green' : 'red'" dark>
                    {{ item.nota_m7 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m8`]="{ item }">
                <v-chip small :color="item.nota_m8 == null ? 'grey' : item.migrado_nota_m8 ? 'green' : 'red'" dark>
                    {{ item.nota_m8 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m9`]="{ item }">
                <v-chip small :color="item.nota_m9 == null ? 'grey' : item.migrado_nota_m9 ? 'green' : 'red'" dark>
                    {{ item.nota_m9 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m10`]="{ item }">
                <v-chip small :color="item.nota_m10 == null ? 'grey' : item.migrado_nota_m10 ? 'green' : 'red'" dark>
                    {{ item.nota_m10 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m11`]="{ item }">
                <v-chip small :color="item.nota_m11 == null ? 'grey' : item.migrado_nota_m11 ? 'green' : 'red'" dark>
                    {{ item.nota_m11 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m12`]="{ item }">
                <v-chip small :color="item.nota_m12 == null ? 'grey' : item.migrado_nota_m12 ? 'green' : 'red'" dark>
                    {{ item.nota_m12 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m13`]="{ item }">
                <v-chip small :color="item.nota_m13 == null ? 'grey' : item.migrado_nota_m13 ? 'green' : 'red'" dark>
                    {{ item.nota_m13 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m14`]="{ item }">
                <v-chip small :color="item.nota_m14 == null ? 'grey' : item.migrado_nota_m14 ? 'green' : 'red'" dark>
                    {{ item.nota_m14 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m15`]="{ item }">
                <v-chip small :color="item.nota_m15 == null ? 'grey' : item.migrado_nota_m15 ? 'green' : 'red'" dark>
                    {{ item.nota_m15 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m16`]="{ item }">
                <v-chip small :color="item.nota_m16 == null ? 'grey' : item.migrado_nota_m16 ? 'green' : 'red'" dark>
                    {{ item.nota_m16 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m17`]="{ item }">
                <v-chip small :color="item.nota_m17 == null ? 'grey' : item.migrado_nota_m17 ? 'green' : 'red'" dark>
                    {{ item.nota_m17 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m18`]="{ item }">
                <v-chip small :color="item.nota_m18 == null ? 'grey' : item.migrado_nota_m18 ? 'green' : 'red'" dark>
                    {{ item.nota_m18 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m19`]="{ item }">
                <v-chip small :color="item.nota_m19 == null ? 'grey' : item.migrado_nota_m19 ? 'green' : 'red'" dark>
                    {{ item.nota_m19 }}
                </v-chip>
            </template>
            <template v-slot:[`item.nota_m20`]="{ item }">
                <v-chip small :color="item.nota_m20 == null ? 'grey' : item.migrado_nota_m20 ? 'green' : 'red'" dark>
                    {{ item.nota_m20 }}
                </v-chip>
            </template>
            <template v-slot:[`item.observaciones`]="{ item }">
                <div v-if="item.observaciones">
                    <ul v-if="parsedObservaciones(item.observaciones).length">
                        <li v-for="(obs, index) in parsedObservaciones(item.observaciones)" :key="index">
                            <strong>{{ obs.metodo }}:</strong> {{ obs.error }}
                        </li>
                    </ul>
                    <span v-else>-</span>
                </div>
            </template>
            <template v-slot:[`item.estado_academico`]="{ item }">
                <v-chip small :color="item.estado_academico_migrado ? 'green' : 'red'" dark>
                    {{ item.estado_academico }}
                </v-chip>
            </template>
            <template v-slot:[`item.estado_titulo`]="{ item }">
                <v-chip small :color="item.estado_titulacion_migrado ? 'green' : 'red'" dark>
                    {{ item.estado_titulo }}
                </v-chip>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { headers } from './utils.js'
import xaxios from '@/xaxios';

export default {
    components: {},
    data: () => ({
        headers,
        loading: false,
        desserts: [],
        search: '',
        fsucursales: [
            { id: 'sucursal-0', text: 'Sucursal 0' },
            { id: 'sucursal-1', text: 'Sucursal 1' },
        ],
        fpuntos: [
            { id: 'punto-0', text: 'Punto 0' },
            { id: 'punto-1', text: 'Punto 1' },
            { id: 'punto-2', text: 'Punto 2' },
            { id: 'punto-3', text: 'Punto 3' },
        ],
        festado_sistema: [
            { id: 'estadosys-true', text: 'Registrado' },
            { id: 'estadosys-false', text: 'No registrado' },
        ],
        festados: [
            { id: 'estado-VALIDA', text: 'VALIDA' },
        ],
        fdocsector: [
            { id: 'docsector-1', text: 'Sector 1' },
            { id: 'docsector-3', text: 'Sector 3' },
            { id: 'docsector-11', text: 'Sector 11' },
        ]
    }),
    methods: {
        parsedObservaciones(observacionesStr) {
            try {
                const parsed = JSON.parse(observacionesStr)
                return Array.isArray(parsed) ? parsed : []
            } catch (e) {
                return []
            }
        },
        async get_datos(endpoint, mes, anio, nit) {
            window.console.log(endpoint, mes, anio, nit)
            this.desserts = [];
            this.loading = true;
            let s = window.localStorage.getItem('TOKEN');
            //relogin( auth );
            let decryptedBytes = window.CryptoJS.AES.decrypt(s, 'estanoesunaclavesecreta');
            let plaintext = decryptedBytes.toString(window.CryptoJS.enc.Utf8);
            let accessToken = plaintext;
            // window.console.log('----->>>>', nit);
            let url = process.env.VUE_APP_API_REST + `/api/v1/esam/migracion_academico`;
            let config = {
                method: 'get',
                url: url,
                headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            };
            let res = await await xaxios.request(config).then(({ data }) => data).catch(e => e)

            if (res && res.data) {
                const sucursalesMap = new Map();
                const puntosMap = new Map();
                const estadosMap = new Map();
                const docSectorMap = new Map();

                for (let i = 0; i <= res.data.length; i++) {
                    let x = res.data[i];
                    if (!x) continue;
                    let o = { id: 'sucursal-' + x.sucursalCuf, text: 'Sucursal ' + x.sucursalCuf };
                    sucursalesMap.set(o.id, o);

                    let o2 = { id: 'punto-' + x.puntoVentaCuf, text: 'Punto ' + x.puntoVentaCuf };
                    puntosMap.set(o2.id, o2);

                    let o3 = { id: 'estado-' + x.estado, text: '' + x.estado };
                    estadosMap.set(o3.id, o3);

                    let o4 = { id: 'docsector-' + x.tipoDocumentoSectorCuf, text: '' + x.tipoDocumentoSectorCuf };
                    docSectorMap.set(o4.id, o4);
                }

                this.fsucursales = Array.from(sucursalesMap.values());
                this.fpuntos = Array.from(puntosMap.values());
                this.festados = Array.from(estadosMap.values());
                this.fdocsector = Array.from(docSectorMap.values());

                this.desserts = res.data;
            }
            this.loading = false;
        },
        custom_filter(value, search, item) {
            if (!search) return true;

            if ((search + '').startsWith('sucursal-')) {
                let id = (search + '').split('-')[1];
                if (item.sucursalCuf == id) return true;
                return false;
            }
            else if ((search + '').startsWith('punto-')) {
                let id = (search + '').split('-')[1];
                if (item.puntoVentaCuf == id) return true;
                return false;
            }
            else if ((search + '').startsWith('estadosys-')) {
                let id = (search + '').split('-')[1];
                // window.console.log('item.registradoSistema == id',item.registradoSistema+'',id);
                if (item.registradoSistema + '' == id) return true;
                return false;
            }
            else if ((search + '').startsWith('estado-')) {
                let id = (search + '').split('-')[1];
                if (item.estado == id) return true;
                return false;
            }
            else if ((search + '').startsWith('docsector-')) {
                let id = (search + '').split('-')[1];
                if (item.tipoDocumentoSectorCuf == id) return true;
                return false;
            }
            // window.console.log('--???',value,search,item);

        },
    },
    mounted() {
        // this.get_datos();
    }
}

</script>

<style scoped>
.tabla-scroll {
    height: 100%;
    max-height: 100%;
    overflow: auto;
}

/* Fijar la primera columna */
.fixed-table ::v-deep th:first-child,
.fixed-table ::v-deep td:first-child {
    position: sticky;
    left: 0;
    background: white;
    z-index: 3;
    box-shadow: 2px 0 2px -1px rgba(0, 0, 0, 0.1);
}

/* Fijar la cabecera */
.fixed-table ::v-deep thead th {
    position: sticky;
    top: 0;
    background: white;
    z-index: 2;
}
</style>
